export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-50 scroll-mt-[72px]">
      <div className="max-w-[1440px] mx-auto">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-background-50 mb-4">随时随地，畅享漫画世界</h2>
              <p className="text-sm text-background-50/80 leading-relaxed mb-6">
                土豪漫画网全面适配移动端阅读，无需下载App，打开浏览器即可享受流畅的下拉式阅读体验。
                无论你在地铁上、午休时还是睡前，随时随地追更你最爱的韩漫、日漫、国漫。
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-medium text-sm rounded-full whitespace-nowrap transition-all cursor-pointer hover:bg-background-100"
                >
                  <i className="ri-smartphone-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  手机端体验
                </a>
                <a
                  href="#topics"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-white/15 text-background-50 font-medium text-sm rounded-full whitespace-nowrap transition-all cursor-pointer hover:bg-white/25 border border-white/20"
                >
                  <i className="ri-compass-3-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  开始探索
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20displaying%20colorful%20manga%20webtoon%20reading%20screen%20in%20vertical%20scroll%20mode%2C%20modern%20phone%20mockup%2C%20clean%20background%2C%20warm%20ambient%20light%2C%20professional%20product%20presentation%2C%20minimalist%20style&width=600&height=800&seq=app-mobile&orientation=portrait"
                alt="土豪漫画移动端阅读体验"
                className="w-48 md:w-56 h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}